module.exports = __webpack_public_path__ + "static/media/basket.9cc5cd40.svg";